import { axios } from "@/utils/request";

//post
export function postAction(url, parameter) {
	console.log("postAction(): url=", url, "parameter=", parameter)
	return axios({
		url: url,
		method: "POST",
		data: parameter,
	});
}
//get
export function getAction(url, params, config) {
	// console.log("getAction(): url=", url, "params=", params)
	return axios({
		url,
		method: "GET",
		params,
		...config,
	});
}
